export const mapAudioAttachment = ({
  file,
  duration,
}: {
  file: File;
  duration: number;
}) => ({
  name: file.name,
  contentLength: file.size,
  duration,
  contentType: file.type,
  url: URL.createObjectURL(file),
  file: file,
});
